import { useEffect, useRef } from 'react';

// Stack of open modal layers (sheets, dialogs, menus) so only the topmost one
// reacts to Escape when several are open (e.g. Equalizer over Audio Boost).

const stack: symbol[] = [];

export function isTopLayer(id: symbol): boolean {
  return stack[stack.length - 1] === id;
}

/** Registers a modal layer while `active`; Escape on the top layer calls `onEscape`. */
export function useTopLayer(active: boolean, onEscape?: () => void): void {
  const escapeRef = useRef(onEscape);
  escapeRef.current = onEscape;

  useEffect(() => {
    if (!active) return;
    const id = Symbol('layer');
    stack.push(id);
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || !isTopLayer(id) || !escapeRef.current) return;
      event.preventDefault();
      escapeRef.current();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      const index = stack.indexOf(id);
      if (index >= 0) stack.splice(index, 1);
    };
  }, [active]);
}
